<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-px-lg container-landfillPage full-width row">
            <span v-if="elements.length == 1" class="col-12">
              <jt-dynamic-form
                ref="dynamicForm"
                :inputs="elements[0].inputs"
                :relacionamentos="elements[0].relacionamentos"
                :model="elements[0].dadosForm"
                :interface="elements[0].nmInterface"
                form-class="form dynamic"
                @search-found="selections"
              />
            </span>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div
      class="row full-width q-col-gutter-lg justify-center q-py-sm"
      v-if="forms[0] && forms[0].buttons.length > 0"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm"
          ><translate>CLEAN</translate></q-btn
        >
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn class="full-width" color="info" @click="actionButton(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtSelect, JtDataGrid } from 'jtech-webcomps'
import { repository } from 'jtech'
const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'landfillPage',
  components: { JtSelect, JtDataGrid },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
export default class LandfillPage extends Vue {
  nmInterface = null;

  beforeMount () {
    this.nmInterface = this.elements[0].nmInterface.split('.')[1]
  }

  selections (data) {
    if (data.userWaste?.idField) {
      this.updateDadosForm(data.userWaste.idField, 'userWaste.pesquisar')
    }
    if (data.company?.idField) {
      this.updateDadosForm(data.company.idField, 'company.pesquisarSelecao')
    }
    if (data.address?.idField) {
      this.updateDadosForm(data.address.idField, 'address.pesquisarSelecao')
    } else {
      if (data.userWaste != undefined && !data.userWaste.idField) {
        this.elements[0].dadosForm.userWaste = null
        this.elements[0].dadosForm.dsEmailUsuario = null
      }
      if (data.company != undefined && !data.company?.idField) {
        this.elements[0].dadosForm.company = null
        this.elements[0].dadosForm.person = null
      }
      if (data.address != undefined && !data.address?.idField) {
        this.elements[0].dadosForm.address = null
        this.elements[0].dadosForm.complement = null
        this.elements[0].dadosForm.number = null
        this.elements[0].dadosForm.state = null
        this.elements[0].dadosForm.city = null
        this.elements[0].dadosForm.neighborhood = null
        this.elements[0].dadosForm.country = null
        this.elements[0].dadosForm.zipCode = null
      }
    }
    this.$forceUpdate()
  }

  async updateDadosForm (idField, interfaceName) {
    const param = { id: idField }
    const { registros } = await repository.resolveDatatableModel(
      interfaceName,
      param
    )
    delete registros[0].id

    delete registros[0].idAcaoGrid

    this.elements[0].dadosForm = {
      ...this.elements[0].dadosForm,
      ...registros[0]
    }
  }

  getParams () {
    const dadosForm = this.forms[0].dadosForm
    if (this.nmInterface === 'pesquisar') {
      return { ...dadosForm, ...{ level: null } }
    }
    return dadosForm
  }
}
</script>
<style lang="stylus" scoped>
.container-landfillPage{
  .dynamic-form #scroll-area{
    height: calc(70vh - 10px) !important;
  }

@media only screen and (max-height: 898px) {
  .dynamic-form {
    #scroll-area {
      height: calc(70vh - 10px) !important;
    }
  }
}

@media only screen and (max-height: 810px) {
  .dynamic-form {
    #scroll-area {
      height: calc(65vh - 10px) !important;
    }
  }
}

 }
</style>
